import FetchData from '../ServerCall/FetchData';
import { IFilter } from '../DataSet/types/BottomBarInterfaces';
import Logger from '../../Logger';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';
import { initialState } from '../DbConnection/Data';
import { TDatabase } from '../../types/types';
import { IGetMetaDataColumns } from '../../api/types/dataset';
import { ChartPropChartAxes } from '../../redux/ChartPoperties/ChartPropertiesInterfaces';
import { ICalculationStep } from '../../redux/Calculations/CurrentCalculationSessionInterface';
import ChartsInfo from '../ChartAxes/ChartsInfo2';
import { getColumnTypes } from '../../api';
import { ChartDataFieldProps } from '../Charts/ChartsCommonInterfaces';

export const isNameAllowed = (name: string): boolean => /^[a-zA-Z0-9 _-]+$/.test(name);

export const GetWorkSpaceDetails = (
  workSpaceList: any,
  workSpaceId: string,
  isSubWorkSpace: boolean = false,
) => {
  if (isSubWorkSpace) {
    let parentWorkspace: any = null;
    let current: any = null;

    [...workSpaceList].forEach((item: any) => {
      if (!current) {
        current = item.children.find((subItem: any) => subItem.id === workSpaceId);

        if (current) {
          parentWorkspace = item;
          return;
        }
      }
    });

    return {
      parentId: parentWorkspace.id,
      subWorkspaceId: current.id,
      label: parentWorkspace.label,
      subLabel: current.label,
    };
  } else {
    return workSpaceList.find((item: any) => item.id === workSpaceId);
  }
};

export const DeleteAllCookies = () => {
  const cookies = document.cookie.split(';');

  for (let cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
};

export const ConvertListOfListToRichTreeViewList = (list: any) => {
  let treeView: any = [];

  list.forEach((woskspaces: any) => {
    let item: any = {
      id: woskspaces.workspaceId,
      label: woskspaces.workspaceName,
      children: [],
    };

    woskspaces.subWorkspaces.forEach((subWorkSpaces: any) => {
      let innerItem = {
        id: subWorkSpaces.workspaceId,
        label: subWorkSpaces.workspaceName,
      };

      item.children.push(innerItem);
    });

    treeView.push(item);
  });

  return treeView;
};

export const ConvertListOfListToDataConnectionRichTreeViewList = (
  list: any,
  icon: string = 'dbcon',
) => {
  let treeView: any = [];

  list.forEach((woskspaces: any) => {
    let item: any = {
      id: woskspaces.workspaceId,
      label: woskspaces.workspaceName,
      children: [],
    };

    woskspaces.subWorkspaces.forEach((subWorkSpace: any) => {
      let innerItem: any = {
        id: subWorkSpace.workspaceId,
        label: subWorkSpace.workspaceName,
        children: [],
      };

      subWorkSpace.contents.forEach((dbCon: any) => {
        let itemWithNoChildren = {
          id: dbCon.id,
          label: dbCon.name,
          fileType: icon,
          vendor: dbCon.vendor,
        };

        innerItem.children.push(itemWithNoChildren);
      });

      item.children.push(innerItem);
    });

    woskspaces.contents.forEach((dbCon: any) => {
      let itemWithNoChildren: any = {
        id: dbCon.id,
        label: dbCon.name,
        fileType: icon,
        vendor: dbCon.vendor,
      };

      item.children.push(itemWithNoChildren);
    });

    if (item.children.length === 0) {
      delete item.children;
    }

    treeView.push(item);
  });

  return treeView;
};
interface Item {
  fileType: string;
  id: string;
  label: string;
  [key: string]: any; // if there are other dynamic fields
}

export const flattenList = (list: Item[], workSpaceId: string = ''): Item[] => {
  return list.reduce<Item[]>((acc, item) => {
    if (Array.isArray(item.children)) {
      return acc.concat(flattenList(item.children, item.id));
    } else {
      const newItem = { ...item, workSpaceId };
      return acc.concat(newItem);
    }
  }, []);
};

export const validateEmail = (email: string) => {
  const res =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var result = res.test(String(email).toLowerCase());
  return result;
};

export const validateMandatory = (value: string) => {
  if (value) {
    return value.length >= 1 ? true : false;
  } else {
    return false;
  }
};

export const validatePassword = (password: string) => {
  // return password.length >= 8 ? true : false;
  // TODO: need to change 4 to 6 after testing
  return password.length >= 4 ? true : false;
};

export const validateEqualValues = (value1: string, value2: string) => {
  return value1 === value2;
};

export const interpolateColor = (startColor: any, endColor: any, steps: any) => {
  const parseColor = (color: any) => {
    if (!color) return [255, 255, 255, 1];

    // Handle hex colors
    if (color.toString().startsWith('#')) {
      let hex = color.slice(1);
      if (hex.length === 3)
        hex = hex
          .split('')
          .map((c: any) => c + c)
          .join('');
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return [r, g, b, 1];
    }

    // Handle rgb/rgba colors
    const match = color.toString().match(/(\d+(\.\d+)?)/g);
    if (match) {
      return [
        Number(match[0]), // r
        Number(match[1]), // g
        Number(match[2]), // b
        match[3] !== undefined ? Number(match[3]) : 1, // a (default to 1)
      ];
    }

    return [255, 255, 255, 1]; // Fallback
  };

  // Parse start and end colors
  const start = parseColor(startColor);
  const end = parseColor(endColor);

  // Generate interpolated colors
  return Array.from({ length: steps }, (_, index) => {
    const t = steps > 1 ? index / (steps - 1) : 0;

    const r = Math.round(start[0] + (end[0] - start[0]) * t);
    const g = Math.round(start[1] + (end[1] - start[1]) * t);
    const b = Math.round(start[2] + (end[2] - start[2]) * t);
    // Alpha needs decimal precision, use toFixed(2)
    const a = (start[3] + (end[3] - start[3]) * t).toFixed(3);

    return `rgba(${r},${g},${b},${Number(a)})`;
  });
};

export const generateRandomColorArray = (length: number) => {
  const colorArray = [];

  for (let i = 0; i < length; i++) {
    colorArray.push(_getRandomcolor());
  }

  return colorArray;
};

const _getRandomcolor = (): any => {
  let randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);

  if (isValidColor(randomColor)) {
    return randomColor;
  } else {
    return _getRandomcolor();
  }
};

const getRelativeLuminance = (color: any) => {
  let r, g, b, a;

  const rgbaRegex = /rgba\(\d+,\d+,\d+,\d+(\.\d+)?\)/;

  // Find the first match
  const match = color.match(rgbaRegex);

  if (match) {
    // Extract the components
    const rgbaParts = color.match(/\d+(\.\d+)?/g); // Matches numbers
    [r, g, b, a] = rgbaParts?.map(Number);
  } else {
    let rgb = parseInt(color.slice(1), 16); // Convert hex to decimal
    r = (rgb >> 16) & 0xff;
    g = (rgb >> 8) & 0xff;
    b = (rgb >> 0) & 0xff;
  }

  const sRGB = [r / 255, g / 255, b / 255];
  const sRGBTransform = sRGB.map((val) => {
    if (val <= 0.04045) {
      return val / 12.92;
    } else {
      return Math.pow((val + 0.055) / 1.055, 2.4);
    }
  });

  return 0.2126 * sRGBTransform[0] + 0.7152 * sRGBTransform[1] + 0.0722 * sRGBTransform[2];
};

export const getContrastColor = (backgroundColor: string) => {
  // Function to calculate relative luminance

  // Calculate the relative luminance of the background color
  const bgLuminance: any = getRelativeLuminance(backgroundColor);

  // Determine the contrast ratio
  const contrast = (bgLuminance + 0.05) / 0.05; // Add 0.05 to avoid division by zero

  // Choose black or white based on the contrast ratio
  //return contrast > 4.5 ? '#000000' : '#ffffff';
  return contrast > 4.3 ? '#000000' : '#ffffff';
};

const isValidColor = (color: any) => {
  const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  return hexColorRegex.test(color);
};

const _changeJSONObjectOrder = (orderedArray: any, item: any) => {
  const entries = Object.entries(item);

  entries.sort(([keyA], [keyB]) => {
    return orderedArray.indexOf(keyA) - orderedArray.indexOf(keyB);
  });

  return Object.fromEntries(entries);
};

export const changeChartDataToAxesOrder = (chartData: any, chartProp: any, propKey: string) => {
  let fields: any = [];
  let fieldsNames: string[] = [];
  let orderedChartData: any = [];

  switch (chartProp.properties[propKey].chartType) {
    case 'pie':
    case 'rose':
    case 'donut':
    case 'line':
    case 'area':
    case 'step line':
    case 'stackedArea':
    case 'multibar':
    case 'stackedBar':
    case 'horizontalStacked':
    case 'horizontalBar':
    case 'waterfall':
    case 'wordCloud':
      fields = chartProp.properties[propKey].chartAxes[1].fields;
      fields = [...fields, ...chartProp.properties[propKey].chartAxes[2].fields];
      break;
  }

  if (fields && fields.length > 0) {
    for (let field of fields) {
      fieldsNames.push(fieldName(field));
    }

    chartData.forEach((data: any) => {
      orderedChartData.push(_changeJSONObjectOrder(fieldsNames, data));
    });

    return orderedChartData;
  } else {
    return chartData;
  }
};

export const getLabelValues = async (
  columnName: string,
  chartControls: any,
  chartProperties: any,
  propKey: string,
  token: string,
  defaultThemeName: any,
  combinedThemes: any,
) => {
  try {
    let fieldValues: any = [];
    let field: any = {};
    var chartControl: any = chartControls.properties[propKey];
    const themeName = chartControl.colorScheme || defaultThemeName || 'peacock';
    const existingLabel = chartControl.labelValues?.[columnName];

    if (
      existingLabel?.values?.length &&
      (existingLabel.themeName === themeName ||
        (!chartControl.colorScheme && themeName === defaultThemeName))
    ) {
      return existingLabel.values;
    } else {
      if (chartControl.labelValues?.[columnName]) {
        delete chartControl.labelValues[columnName];
      }
    }

    let chartThemes = combinedThemes.filter((el: any) => el.name === themeName);
    if (chartThemes.length === 0) {
      chartThemes = combinedThemes.filter((el: any) => el.name === 'peacock');
    }

    // checking the column type To generate the name as it is in the chartData
    // chartProperties.properties[propKey].chartAxes[1].fields.forEach(async (el: any) => {
    // 	//if (el.dataType === "date") {
    // 	;
    // 	if (columnName.includes(el.fieldname)) {
    // 		//formattedColumnName = `${el.timeGrain} of ${el.fieldname}`;
    // 		if(["date", "timestamp"].includes(el.dataType)){
    // 			if(columnName.split(' of ')[0] === el.timeGrain){
    // 				field = el;
    // 				return;
    // 			}
    // 		}
    // 		else{
    // 			field = el;
    // 			return;
    // 		}
    // 	}
    // 	//}
    // });

    // checking the column type To generate the name as it is in the chartData
    chartProperties.properties[propKey].chartAxes[1].fields.forEach(async (el: any) => {
      //if (el.dataType === "date") {

      // if (columnName.includes(el.fieldname)) {
      if (columnName === el.displayname) {
        //formattedColumnName = `${el.timeGrain} of ${el.fieldname}`;
        if (['date', 'timestamp'].includes(el.dataType)) {
          // if (columnName.split(" of ")[0] === el.timeGrain) {
          field = el;
          return;
          // }
        } else {
          field = el;
          return;
        }
      }
      //}
    });

    let formattedColumnName = ['date', 'timestamp'].includes(field.dataType)
      ? field.timeGrain
      : field.fieldname;
    fieldValues = await fetchFieldData(field, chartProperties, propKey, token);
    formattedColumnName = Object.keys(fieldValues?.data)?.find(
      (key) => key.toLowerCase() === formattedColumnName.toLowerCase(),
    );

    //let colors = interpolateColor("#2BB9BB", "#D87A80", fieldValues?.data?.length);
    let length =
      chartThemes[0].colors.length > fieldValues?.data?.[formattedColumnName]?.length
        ? chartThemes[0].colors.length - fieldValues?.data?.[formattedColumnName]?.length
        : fieldValues?.data?.[formattedColumnName]?.length - chartThemes[0].colors.length;

    let randomColors = generateRandomColorArray(length);
    let colors = chartThemes[0].colors;

    colors = [...colors, ...randomColors];

    const oldValuesMap: Record<string, any> = {};
    existingLabel?.values?.forEach((v: any) => {
      oldValuesMap[v.colValue] = v;
    });

    const values = fieldValues?.data[formattedColumnName]?.map((item: any, idx: number) => {
      const oldVal = oldValuesMap[item];
      return {
        colValue: item,
        backgroundColor: colors[idx],
        isBold: oldVal?.isBold ?? false,
        isItalic: oldVal?.isItalic ?? false,
        isUnderlined: oldVal?.isUnderlined ?? false,
        fontColor: oldVal?.fontColor ?? getContrastColor(colors[idx]),
      };
    });

    chartControl.labelValues = {
      ...chartControl.labelValues,
      [columnName]: {
        themeName,
        values,
      },
    };

    return values;
  } catch (err) {
    console.error(err);
  }
};

const _findFieldName = (name: string, i: number = 2, _fieldTempObject: any): string => {
  if (_fieldTempObject[`${name}(${i})`] !== undefined) {
    i++;
    return _findFieldName(name, i, _fieldTempObject);
  } else {
    return `${name}(${i})`;
  }
};

export const FindFieldName = (name: string, i: number = 2): string => {
  let _fieldTempObject: any = {};

  return _findFieldName(name, i, _fieldTempObject);
};

export const fieldName = (field: any) => {
  if (field) {
    if (field.agg || field.timeGrain) {
      if (['date', 'timestamp'].includes(field.dataType)) {
        return `${field.timeGrain} of ${field.fieldname}`;
      } else {
        return `${field.agg} of ${field.fieldname}`;
      }
    } else {
      return field.fieldname;
    }
  } else {
    return field;
  }
};

export const displayName = (field: any) => {
  if (field) {
    return field.displayname;
  }
  return field;
};

export const findNewDisplayName = (
  chartAxes: any,
  paramField: any,
  tooltipFormats?: any,
  specialNames?: string[],
): any => {
  let _fieldTempObject: any = {};

  /*	Find and return field's new name	*/
  const findFieldName = (name: string, i: number = 0): string => {
    if (
      (specialNames && specialNames.includes(i === 0 ? name : `${name}(${i})`)) ||
      (i === 0 && _fieldTempObject[name] !== undefined) ||
      _fieldTempObject[`${name}(${i})`] !== undefined
    ) {
      i = i === 0 ? 1 : i;

      i++;
      return findFieldName(name, i);
    } else {
      if (i === 0) {
        return name;
      } else {
        return `${name}(${i})`;
      }
    }
  };

  chartAxes.forEach((zones: any) => {
    if (zones.name !== 'Filter') {
      zones?.fields.forEach((field: any, index: number) => {
        let _nameWithAgg: string = '';
        let _tempField = JSON.parse(JSON.stringify(field));

        _nameWithAgg = _tempField.displayname;

        if (
          _fieldTempObject[_nameWithAgg] !== undefined ||
          (specialNames && specialNames.includes(_nameWithAgg))
        ) {
          let _name = findFieldName(_nameWithAgg);
          _tempField['NameWithAgg'] = _name;
          _fieldTempObject[_name] = '';
        } else {
          _tempField['NameWithAgg'] = _nameWithAgg;
          _fieldTempObject[_nameWithAgg] = '';
        }
      });
    }
  });

  const extraFields = tooltipFormats?.extraMeasureField?.[0]?.fields || [];
  extraFields?.forEach((field: any, index: number) => {
    let _nameWithAgg: string = '';
    let _tempField = JSON.parse(JSON.stringify(field));

    _nameWithAgg = _tempField.displayname;

    if (
      _fieldTempObject[_nameWithAgg] !== undefined ||
      (specialNames && specialNames.includes(_nameWithAgg))
    ) {
      let _name = findFieldName(_nameWithAgg);
      _tempField['NameWithAgg'] = _name;
      _fieldTempObject[_name] = '';
    } else {
      _tempField['NameWithAgg'] = _nameWithAgg;
      _fieldTempObject[_nameWithAgg] = '';
    }
  });

  let newName = findFieldName(paramField.displayname);
  return newName || paramField.displayname;
};

const fetchFieldData = (bodyData: any, chartProperties: any, propKey: string, token: string) => {
  //  bodyData: any = {
  // 	tableId: tableId,
  // 	fieldName: displayname,
  // 	dataType: dataType,
  // 	filterOption: "allValues",
  // };
  if (bodyData.dataType === 'timestamp' || bodyData.dataType === 'date') {
    bodyData['timeGrain'] = bodyData.timeGrain || 'year';
  }

  let link: string = '';

  if (window.location.href.includes('dashboard')) {
    let url = window.location.href.split('/').slice(-1);
    link = url.toString();
  }

  let _url;

  if (link && link !== '') {
    _url = `open-link/filter-options?dbconnectionid=${chartProperties.properties[propKey].selectedDs.connectionId}&datasetid=${chartProperties.properties[propKey].selectedDs.id}&linkId=${link}`;
  } else {
    _url = `filter-options?dbconnectionid=${chartProperties.properties[propKey].selectedDs.connectionId}&datasetid=${chartProperties.properties[propKey].selectedDs.id}&workspaceId=${chartProperties.properties[propKey].selectedDs.workSpaceId}`;
  }

  bodyData.filterOption = 'allValues';
  bodyData.fieldName = bodyData.fieldname;
  // bodyData.displayName = bodyData.displayname

  return FetchData({
    checkToken: link === '',
    requestType: 'withData',
    method: 'POST',
    url: _url,
    headers:
      link && link !== ''
        ? { 'Content-Type': 'application/json', 'X-TENANT-ID': 'community' }
        : {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
    data: bodyData,
  });
};

export const modifyFilter = (filter: any, savedCalculations?: any[]): IFilter => {
  const getCalculationByUid = (uid: string, savedCalculations?: any[]) => {
    if (!uid || !savedCalculations) return null;
    return savedCalculations.find((calculation) => calculation.uuid === uid);
  };

  const calculation = getCalculationByUid(filter.SavedCalculationUUID, savedCalculations);
  let calculationDetails: any;
  let sortedDependency = true;
  if (calculation) {
    calculationDetails = {
      calculatedField: [
        {
          calculatedFieldName: calculation.name,
          fields: calculation.calculationInfo.fields,
          flows: calculation.calculationInfo.flows,
          conditionFilters: calculation.calculationInfo.conditionFilters,
          overrided: calculation.calculationInfo.overrideCount > 0,
          isAggregated: calculation.isAggregated ?? false,
        },
      ],
      isCalculatedField: true,
    };
  }

  if (filter.fieldtypeoption === 'Pick List') {
    return {
      filterType:
        filter.exprTypeTillDate && filter.filterTypeTillDate === 'enabled'
          ? 'tillDate'
          : 'pickList',
      tableId: filter.tableId,
      uid: filter.uId,
      dataType: filter.dataType,
      fieldName: filter.fieldname,
      shouldExclude: filter.includeexclude.toLowerCase() === 'exclude' ? true : false,
      operator: 'in',
      tableName: '',
      isTillDate: filter.exprTypeTillDate ?? false,
      userSelection: filter.userSelection?.filter((el: any) => el !== '(All)'),
      ...(filter.dataType === 'date' || filter.dataType === 'timestamp'
        ? { timeGrain: filter.prefix }
        : {}),
      ...(calculation && sortedDependency ? { ...calculationDetails } : {}),
    };
  } else if (filter.fieldtypeoption === 'Search Condition') {
    return {
      filterType: 'searchCondition',
      tableId: filter.tableId,
      tableName: '',
      uid: filter.uId,
      isTillDate: filter.exprTypeTillDate ?? false,
      dataType: filter.dataType,
      fieldName: filter.fieldname,
      operator: filter.exprType,
      shouldExclude: filter.includeexclude.toLowerCase() === 'exclude' ? true : false,
      userSelection:
        filter.exprType === 'between'
          ? [filter.greaterThanOrEqualTo, filter.lessThanOrEqualTo]
          : [filter.exprInput],
      ...(filter.dataType === 'date' || filter.dataType === 'timestamp'
        ? { timeGrain: filter.prefix }
        : {}),
      ...(calculation && sortedDependency ? { ...calculationDetails } : {}),
    };
  } else if (filter.fieldtypeoption === 'Relative Filter') {
    // return {}
    return {
      filterType: 'relativeFilter',
      tableId: filter.tableId,
      uid: filter.uId,
      dataType: filter.dataType,
      fieldName: filter.fieldname,
      shouldExclude: filter.includeexclude.toLowerCase() === 'exclude' ? true : false,
      operator: 'between',
      tableName: '',
      isTillDate: filter.exprTypeTillDate ?? false,
      timeGrain: 'date',
      userSelection: [],
      relativeCondition: {
        from: [
          filter.expTypeFromRelativeDate,
          filter.exprInputFromValueType,
          filter.expTypeFromdate,
        ],
        to: [filter.expTypeToRelativeDate, filter.exprInputToValueType, filter.expTypeTodate],
        anchorDate:
          filter.expTypeAnchorDate !== 'today'
            ? filter.expTypeAnchorDate
            : filter.expTypeAnchorDate,
      },
      ...(calculation && sortedDependency ? { ...calculationDetails } : {}),
    };
  } else if (filter.fieldtypeoption === 'Top N') {
    return {
      filterType: 'topn',
      aggr: filter.aggr ?? 'sum',
      tableId: filter.tableId,
      uid: filter.uId,
      dataType: filter.dataType,
      fieldName: filter.fieldname,
      shouldExclude: filter.includeexclude.toLowerCase() === 'exclude' ? true : false,
      operator: filter.exprType,
      tableName: '',
      userSelection: [filter.exprInput],
      ...(filter.isCalculatedField && calculation && sortedDependency
        ? { ...calculationDetails }
        : {}),
    };
  } else
    return {
      filterType: 'aggr',
      tableId: filter.tableId,
      tableName: '',
      aggr: filter.aggr ?? 'sum',
      uid: filter.uId,
      isTillDate: filter.exprTypeTillDate ?? false,
      dataType: filter.dataType,
      fieldName: filter.fieldname,
      operator: filter.exprType,
      shouldExclude: filter.includeexclude.toLowerCase() === 'exclude' ? true : false,
      userSelection:
        filter.exprType === 'between'
          ? [filter.greaterThanOrEqualTo, filter.lessThanOrEqualTo]
          : [filter.exprInput],
      ...(filter.dataType === 'date' || filter.dataType === 'timestamp'
        ? { timeGrain: filter.prefix }
        : {}),
      ...(filter.isCalculatedField && calculation && sortedDependency
        ? { ...calculationDetails }
        : {}),
    };
};

const dataTypeMap: { [key: string]: string[] } = {
  number: [
    'INT',
    'INTEGER',
    'BIGINT',
    'SMALLINT',
    'TINYINT',
    'FLOAT',
    'REAL',
    'DOUBLE',
    'DECIMAL',
    'NUMERIC',
    'DOUBLE PRECISION',
  ],
  text: ['CHAR', 'VARCHAR', 'TEXT', 'STRING'],
  date: ['DATE', 'DATETIME', 'TIMESTAMP'],
  boolean: ['BOOLEAN', 'BOOL'],
  // Add more mappings if necessary
};

// Helper function to find the canonical type for a given data type
function getCanonicalType(type: string): string | null {
  for (const [canonicalType, typeList] of Object.entries(dataTypeMap)) {
    if (typeList.includes(type.toUpperCase())) {
      return canonicalType;
    }
  }
  return null; // Return null if type is not found
}

// Main function to compare two types
export function isSimilarDataType(selectedType: string, comparingType: string): boolean {
  const selectedCanonicalType = getCanonicalType(selectedType);
  const comparingCanonicalType = getCanonicalType(comparingType);

  if (selectedCanonicalType && comparingCanonicalType) {
    return selectedCanonicalType === comparingCanonicalType;
  }

  return false; // Return false if one or both types are not recognized
}

/**
 *
 * @param value
 * @returns the sql data type of the value
 */
export function getSQLDataType(value: any) {
  if (value === null) return 'blank';

  switch (value) {
    case 'field':
      return 'field';
    case 'flow':
      return 'flow';
  }

  switch (typeof value) {
    case 'string':
      return 'text';
    case 'number':
      // Check for integers and floating-point numbers
      return Number.isInteger(value) ? 'integer' : 'decimal';
    case 'boolean':
      return 'boolean';
    case 'object':
      if (Array.isArray(value)) return 'text'; // Arrays often stored as TEXT or JSON
      if (value instanceof Date) return 'datetime'; // Date objects often stored as DATETIME
      if (value instanceof Buffer) return 'blob'; // Binary data like images/files
      return 'JSON'; // Objects often stored as JSON in SQL databases

    default:
      return 'text'; // Default fallback for unsupported types
  }
}

export function areNestedObjectsEqual(
  obj1Str: string,
  obj2Str: string,
  ignoreKeys?: string[],
): boolean {
  try {
    // Parse the JSON strings into objects
    const obj1 = JSON.parse(obj1Str);
    const obj2 = JSON.parse(obj2Str);

    function deepCompare(obj1: any, obj2: any): boolean {
      if (typeof obj1 !== typeof obj2) return false;

      if (typeof obj1 !== 'object' || obj1 === null || obj2 === null) {
        return obj1 === obj2; // Primitive or null comparison
      }

      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) return false;

      for (const key of keys1) {
        if (ignoreKeys && ignoreKeys.includes(key)) continue;
        if (!keys2.includes(key)) return false;
        if (!deepCompare(obj1[key], obj2[key])) return false;
      }

      return true;
    }

    return deepCompare(obj1, obj2);
  } catch (error) {
    return false; // Return false if the input strings are not valid JSON
  }
}
export function deletePlaybookDetailsFromSessionStorage() {
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith('pb_id_')) {
      sessionStorage.removeItem(key);
      i--;
    }
  }
}

export const updateSampleRecords = (
  sampleRecords: Record<string, any>,
  id: string,
  tableId: string,
  tableRecords: Record<string, any>,
  headersData: IGetMetaDataColumns[],
) => {
  let newSampleRecords: any = {};
  if (sampleRecords?.[id] !== undefined) {
    newSampleRecords = {
      ...sampleRecords,
      [id]: {
        ...sampleRecords[id],
        [tableId]: tableRecords,
      },
      recordsColumnType: {
        ...sampleRecords.recordsColumnType,
        [id]: {
          ...(sampleRecords.recordsColumnType[id] || {}),
          [tableId]: headersData,
        },
      },
    };
  } else {
    newSampleRecords = {
      ...sampleRecords,
      [id]: {
        [tableId]: tableRecords,
      },
      recordsColumnType: {
        ...sampleRecords.recordsColumnType,
        [id]: {
          [tableId]: headersData,
        },
      },
    };
  }
  return newSampleRecords;
};

export const getCalculationByUid = (
  uid: string,
  chartType: string,
  axes: any[],
  savedCalculations?: any[],
) => {
  if (!uid || !savedCalculations || !chartType || !axes) return {};
  const calc = savedCalculations.find((calculation) => calculation.uuid === uid);
  if (!calc) return {};
  const flows = calc.calculationInfo.flows;
  Object.keys(flows).forEach((flowKey) => {
    flows[flowKey].forEach((flowCondition: ICalculationStep) => {
      if (
        flowCondition.flow === 'summarize' &&
        flowCondition.flowOverride?.windowFunction &&
        ['crossTab', 'heatmap'].includes(chartType)
      ) {
        const { row, column } = axes.reduce(
          (acc: { row: number; column: number }, axis: any) => {
            if (axis.name === 'Row') acc.row = axis.fields.length;
            if (axis.name === 'Column') acc.column = axis.fields.length;
            return acc;
          },
          { row: 0, column: 0 },
        );
        flowCondition.flowOverride.windowFunction = {
          ...flowCondition.flowOverride.windowFunction,
          windowFnMatrix: [row, column],
        };
      } else if (flowCondition.flow === 'summarize' && flowCondition.flowOverride?.windowFunction) {
        delete flowCondition.flowOverride?.windowFunction?.windowFnMatrix;
      }
      if (flowCondition.flowOverride?.windowFunction) {
        if (
          !['standing', 'sliding'].includes(
            flowCondition.flowOverride.windowFunction.windowFn[0],
          ) &&
          ['first', 'last'].includes(flowCondition.flowOverride.windowFunction.windowFn[1])
        ) {
          delete flowCondition.flowOverride.windowFunction.windowFnOption;
        }
      }
    });
  });

  return {
    calculatedField: [
      {
        calculatedFieldName: calc.calculationInfo.calculatedFieldName.split(' ').join(' '),
        isAggregated: calc.isAggregated,
        fields: calc.calculationInfo.fields,
        flows: flows,
        conditionFilters: calc.calculationInfo.conditionFilters,
        overrided: calc.calculationInfo.overrideCount > 0,
      },
    ],
    isCalculatedField: true,
  };
};

// this function won't allow to type any other characters except digits.
export const handleKeyDown = (
  event: React.KeyboardEvent<HTMLInputElement>,
  allowNegativeValue = false,
) => {
  if (event.key === 'Backspace' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
    return;
  }

  let regexForIntegerNumbers;
  if (allowNegativeValue) {
    regexForIntegerNumbers = /^-$|^-?\d+$/;
  } else {
    regexForIntegerNumbers = /^[0-9]$/;
  }

  if (!regexForIntegerNumbers.test(event.key)) {
    event.preventDefault();
  }
};

// this function checks if a input value is a decimal value or not and returns the boolean value
export const handleDecimalInput = (value: string) => {
  Logger('info', 'value: ', value);
  if (value === '.' || value.startsWith('..')) return;
  if (/^\d*\.?\d*$/.test(value)) {
    if (value.startsWith('0') && value.length > 1 && !value.startsWith('0.')) {
      value = value.replace(/^0+/, '');
    }
    Logger('info', 'passed test: ', value);
    return true;
  }
  return false;
};

// this function checks if a input value is a text value or not and returns the boolean value
export const handleTextInput = (value: string) => {
  Logger('info', 'value: ', value);

  // Reject if the value is purely numeric or empty
  if (!value || /^\d+$/.test(value)) return false;

  // Allow letters, spaces, underscores, and hyphens (adjust as needed)
  const isValid = /^[a-zA-Z _-]+$/.test(value);

  if (isValid) {
    Logger('info', 'passed text test: ', value);
    return true;
  }

  return false;
};

export const getAccessLevel = () => {
  try {
    const token = Cookies.get('authToken');
    if (!token) return null;
    const decodedToken: any = jwtDecode(token);
    return decodedToken.access as string;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};
export const Port = (connection: string) => {
  if (connection === 'postgresql') {
    return '5432';
  }
  if (connection === 'mysql' || connection === 'mariadb') {
    return '3306';
  }
  if (connection === 'clickhouse') {
    return '8123';
  }
  if (connection === 'sqlserver') {
    return '1433';
  }
  if (connection === 'redshift') {
    return '5439';
  }
  if (connection === 'databricks') {
    return '443';
  }
  if (connection === 'oracle') {
    return '1522';
  }
  if (connection === 'db2') {
    return '32459';
  }
  if (connection === 'teradata') {
    return '1025';
  }
  if (connection === 'saphana') {
    return '443';
  } else {
    return '';
  }
};
export const getKey = (label: string) => {
  if (label === 'Connection Name') return 'connectionName';
  if (label === 'Port') return 'port';
  if (label === 'Key Store') return 'keystore';
  if (label === 'Trust Store') return 'truststore';
  if (label === 'Region') return 'region';
  if (label === 'S3 Location') return 's3Location';
  if (label === 'HTTP Path') return 'httpPath';
  if (label === 'vendor') return 'vendor';
  if (label === 'Key Store Password') return 'keystorePassword';
  if (label === 'Trust Store Password') return 'truststorePassword';

  if (['Username', 'Access Key'].includes(label)) return 'username';
  if (['Token', 'Secret Key', 'Password'].includes(label)) return 'password';
  if (['Server Hostname', 'Server', 'Host', 'Server Url'].includes(label)) return 'server';
  if (['Service Name', 'Database'].includes(label)) return 'database';
  return '';
};
export const defaultValuesForDB = (vendor: TDatabase) => {
  return {
    ...initialState,
    vendor: vendor,
    port: Port(vendor),
    region: 'us-east-1',
    s3Location: 's3://path/to/your/bucket',
    database: vendor === 'databricks' ? 'default' : '',
    server: ['postgresql', 'mysql', 'sqlserver', 'db2', 'snowflake', 'clickhouse'].includes(vendor)
      ? 'Server name or URL'
      : '',
  };
};
export interface Node {
  id: string;
  label: string;
  children?: Node[];
}

interface Result {
  id: string;
  label: string;
  parentId?: string;
  parentLabel?: string;
}

export function findNodeWithParent(
  nodes: Node[],
  targetId: string,
  parent?: Node,
): Result | undefined {
  for (const node of nodes) {
    if (node.id === targetId) {
      return {
        id: node.id,
        label: node.label,
        parentId: parent?.id,
        parentLabel: parent?.label,
      };
    }
    if (node.children) {
      const result = findNodeWithParent(node.children, targetId, node);
      if (result) return result;
    }
  }
  return undefined;
}
export function toBoolean(str: string) {
  return String(str).toLowerCase() === 'true';
}

/**
 * @returns uId of a key where key is displayname. This function is used in Echart tooltip.
 */
export function getUidOfKey(chartAxes: any, key: string, tooltipFormats?: any) {
  const newChartAxes = chartAxes.filter((axis: any) => axis.name !== 'Filter');
  //-----------checking in extra measure fields ---------------------//
  if (
    tooltipFormats &&
    tooltipFormats.extraMeasureField &&
    tooltipFormats.extraMeasureField[0]?.fields
  ) {
    for (const field of tooltipFormats.extraMeasureField[0].fields) {
      if (field.displayname === key) {
        return field.uId;
      }
    }
  }
  //-----------checking in chartAxes------- //
  for (const axis of newChartAxes) {
    for (const field of axis.fields || []) {
      if (field.displayname === key) {
        return field.uId;
      }
    }
  }
  return '';
}

/**
 * @returns boolean value
 * This function is checking presence of an uId in tooltip checked measure(all these uIds are from measure or other axis in chartAxes).
 */
export function checkUidPresenceInCheckedMeasureForTooltip(
  chartAxes: any,
  displayname: string,
  checkedMeasureUidList: string[],
): boolean {
  for (const axis of chartAxes.slice(1)) {
    if (axis && Array.isArray(axis.fields)) {
      for (const field of axis.fields) {
        if (axis.name === 'Measure' || axis.name === 'X Axis' || axis.name === 'Y Axis') {
          if (field.displayname === displayname) {
            return checkedMeasureUidList.includes(field.uId);
          }
        } else {
          if (
            (field.dataType === 'timestamp' || field.dataType === 'date') &&
            field.timeGrain === 'date'
          ) {
            if (field.displayname === displayname) {
              return checkedMeasureUidList.includes(field.uId);
            }
          } else {
            if (field.displayname === displayname) {
              return true;
            }
          }
        }
      }
    }
  }
  return true;
}

/**
 * @returns an array containing fields
 */
export function getMeasureFieldsIncludingDateTimeGrain(chartAxes: ChartPropChartAxes[]) {
  let measures: any = [];
  chartAxes.slice(1).forEach((axis) => {
    if (axis && Array.isArray(axis.fields)) {
      axis.fields.forEach((field) => {
        if (axis.name === 'Measure' || axis.name === 'X Axis' || axis.name === 'Y Axis') {
          if (field.displayname) {
            measures.push(field);
          }
        } else {
          if (
            axis.name !== 'Distribution' &&
            (field.dataType === 'timestamp' || field.dataType === 'date') &&
            field.timeGrain === 'date'
          ) {
            if (field.displayname) {
              measures.push(field);
            }
          }
        }
      });
    }
  });
  return measures;
}

/**
 *
 * @returns displayname of a field from its unique id
 */
export function getNameFromUid(chartAxes: any, uId: string, tooltipFormats?: any) {
  const newChartAxes = chartAxes.filter((axis: any) => axis.name !== 'Filter');
  if (
    tooltipFormats &&
    tooltipFormats.extraMeasureField &&
    tooltipFormats.extraMeasureField[0]?.fields
  ) {
    for (const field of tooltipFormats.extraMeasureField[0].fields) {
      if (field.uId === uId) {
        return field.displayname;
      }
    }
  }
  for (const axis of newChartAxes) {
    for (const field of axis.fields || []) {
      if (field.uId === uId) {
        return field.displayname;
      }
    }
  }
  return;
}

/**
 * Check if chart data meets minimum requirements for each axis
 * Returns true if chart data has at least the minimum required fields for each non-filter axis
 *
 * Example: For multibar chart with min 1 Dimension and min 1 Measure:
 * - If chartData has 1 dimension + 1 measure -> returns true (shows chart)
 * - If chartData has 1 dimension + 0 measure -> returns false (shows empty state)
 */
export const shouldChartDisplayWithSecurity = (
  chartAxes: any[],
  chartType: string,
  chartData: any[],
): boolean => {
  const dropZonesExceptFilter = ChartsInfo[chartType]?.dropZones?.filter(
    (dropzone: any) => dropzone.name !== 'Filter',
  );

  if (!dropZonesExceptFilter || dropZonesExceptFilter.length === 0) {
    return false;
  }

  if (!chartData || chartData.length === 0) {
    return false;
  }

  const chartDataKeys = Object.keys(chartData[0]);

  //--------- Check if chart data has at least one measure with a valid (non-undefined) value--(start) --------//
  //1- Get all measure field display names from chartAxes
  const measureDisplayNames = new Set<string>();
  for (const axis of chartAxes) {
    if (axis.name === 'Measure' || axis.name === 'X Axis' || axis.name === 'Y Axis') {
      for (const field of axis.fields || []) {
        if (field.displayname) {
          measureDisplayNames.add(field.displayname);
        }
      }
    }
  }

  //2- Find measure keys in chartData (excluding "undefined" keys)
  const measureKeysInData = chartDataKeys.filter(
    (key) => key !== 'undefined' && measureDisplayNames.has(key),
  );

  //3- Count how many measures have non-undefined values
  const validMeasureCount = measureKeysInData.filter(
    (key) => chartData[0][key] !== undefined,
  ).length;

  // If there are measures but none have valid values, return false
  if (measureKeysInData.length > 0 && validMeasureCount === 0) {
    return false;
  }

  // If there's an "undefined" key and no valid measures, return false
  if (chartDataKeys.includes('undefined') && validMeasureCount === 0) {
    return false;
  }

  //-----------------------------------------(End)-----------------------------------------//

  // Check each non-filter axis meets its minimum requirement
  for (let i = 0; i < dropZonesExceptFilter.length; i++) {
    const dropZone = dropZonesExceptFilter[i];
    const minRequired = dropZone.min || 0;

    // Find the corresponding axis (skip filter axis at index 0)
    const axisIndex = i + 1;
    const axis = chartAxes[axisIndex];

    // Get display names for this axis that are present in chart data
    const axisFieldsInData = axis.fields?.filter((field: any) =>
      chartDataKeys.includes(field.displayname),
    );

    const fieldsCount = axisFieldsInData?.length || 0;

    // Check if this axis meets minimum requirement
    if (fieldsCount < minRequired) {
      return false;
    }
  }

  return true;
};

export function arraysMatch(a: any[], b: any[]) {
  if (a.length !== b.length) return false;
  return a.every((val, i) => val === b[i]);
}

export function limitChartData(data: any[], maxPoints: number = 50, displayName: string) {
  if (data.length <= maxPoints) return data;

  const sorted = [...data].sort((a, b) => Number(b[displayName]) - Number(a[displayName]));

  const top = sorted.slice(0, maxPoints);

  const topSet = new Set(top);

  const finalData = data.filter((item: any) => topSet.has(item)); // To maintain original order

  return finalData;
}

export const truncateEmail = (email: string, maxLocalLength = 10) => {
  if (!email || !email.includes('@')) return email;
  const [local, domain] = email.split('@');
  if (local.length <= maxLocalLength) return email;

  const start = local.slice(0, Math.ceil(maxLocalLength / 2));
  const end = local.slice(-Math.floor(maxLocalLength / 2));

  return `${start}…${end}@${domain}`;
};

/**
 * Applies opacity to a color string (HEX, RGB, or RGBA).
 * Useful for separating fill opacity from border opacity in charts.
 */
export const applyOpacityToColor = (color: string, alpha: number): string => {
  if (!color) return color;

  // Handle HEX (#RRGGBB or #RGB)
  if (color.startsWith('#')) {
    let r = 0,
      g = 0,
      b = 0;
    // 3-char hex
    if (color.length === 4) {
      r = parseInt(color[1] + color[1], 16);
      g = parseInt(color[2] + color[2], 16);
      b = parseInt(color[3] + color[3], 16);
    }
    // 6-char hex
    else if (color.length === 7) {
      r = parseInt(color.substring(1, 3), 16);
      g = parseInt(color.substring(3, 5), 16);
      b = parseInt(color.substring(5, 7), 16);
    }
    return `rgba(${r},${g},${b},${alpha})`;
  }

  // Handle RGB
  if (color.startsWith('rgb(')) {
    return color.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);
  }

  // Handle RGBA (replace existing alpha)
  if (color.startsWith('rgba(')) {
    return color.replace(/,[^,]+\)/, `, ${alpha})`);
  }

  return color;
};

// To check if there is any missing column in the payload and if we are switching datasets
export const checkIfMissingColumn = async (
  column: any,
  selectedDs: any,
  tablesOfDataset: any,
  switchDataset = false,
) => {
  const getColumns = sessionStorage.getItem('sampleRecords');
  let isMissing = false;
  const columns = JSON.parse(getColumns || '{}');

  const tableExists = checkIfTableExists(column.tableId, tablesOfDataset);
  if (!tableExists && !switchDataset) {
    return { isMissing: true };
  }

  const recordsColumnType = columns?.recordsColumnType || {};
  const hasValidRecords = Object.keys(recordsColumnType).some(
    (k) => recordsColumnType[k] && Object.keys(recordsColumnType[k] || {}).length > 0,
  );
  let tableColumnsData: any[] = [];
  let sampleRecordsStored = sessionStorage.getItem('sampleRecords');
  let sampleRecords = sampleRecordsStored ? JSON.parse(sampleRecordsStored) : {};

  if (hasValidRecords) {
    tableColumnsData = Object.keys({ ...columns.recordsColumnType?.[selectedDs.id] }).map(
      (key) => ({ [key]: columns.recordsColumnType?.[selectedDs.id]?.[key] }),
    );
    const keys = columns.recordsColumnType?.[selectedDs.id]
      ? Object.keys(columns.recordsColumnType[selectedDs.id])
      : [];
    if (keys && keys.length !== tablesOfDataset.length) {
      const getUnavailableColumnsIds = tablesOfDataset.filter((table: any) => {
        const tableId = table.id ?? table.tableId ?? '';
        return !keys.includes(tableId);
      });
      if (getUnavailableColumnsIds.length > 0) {
        const promises = getUnavailableColumnsIds.map(async (table: any) => {
          const tableId = table.id ?? table.tableId ?? '';
          try {
            const res = await getColumnTypes(
              selectedDs.isExtract,
              selectedDs.connectionId,
              selectedDs.id,
              table,
              selectedDs.workSpaceId,
              null,
              true,
            );
            if (res.data.length > 0) {
              sessionStorage.setItem(
                'sampleRecords',
                JSON.stringify(
                  updateSampleRecords(
                    sampleRecords,
                    selectedDs.id,
                    table.id,
                    sampleRecords?.[selectedDs.id]?.[table.id],
                    res?.data,
                  ),
                ),
              );
            }
            return { tableId, data: res?.data ?? [] };
          } catch (err) {
            console.error('Fetch missing columns getColumnTypes error for table', tableId, err);
            return { tableId, data: [] };
          }
        });

        const results = await Promise.all(promises);
        results.forEach(({ tableId, data }) => {
          if (data && data.length > 0) {
            tableColumnsData.push({ [tableId]: data });
          }
        });
      }
    }
  } else {
    const promises = tablesOfDataset.map(async (table: any) => {
      const tableId = table.id ?? table.tableId ?? '';
      try {
        const res = await getColumnTypes(
          selectedDs.isExtract,
          selectedDs.connectionId,
          selectedDs.id,
          table,
          selectedDs.workSpaceId,
          null,
          true,
        );
        if (res.data.length > 0) {
          sessionStorage.setItem(
            'sampleRecords',
            JSON.stringify(
              updateSampleRecords(
                sampleRecords,
                selectedDs.id,
                table.id,
                sampleRecords?.[selectedDs.id]?.[table.id],
                res?.data,
              ),
            ),
          );
        }
        return { tableId, data: res?.data ?? [] };
      } catch (err) {
        console.error('getColumnTypes error for table', tableId, err);
        return { tableId, data: [] };
      }
    });

    const results = await Promise.all(promises);
    results.forEach(({ tableId, data }) => {
      if (data && data.length > 0) {
        tableColumnsData.push({ [tableId]: data });
      }
    });
  }

  let newTableId = '';
  if (switchDataset) {
    tableColumnsData.forEach((table: any) => {
      const key = Object.keys(table)[0];
      if (table[key] && table[key].length > 0) {
        const fieldName = column?.fieldname ?? column?.fieldName ?? column?.displayname ?? '';
        const dataType = column?.dataType ?? column?.datatype ?? '';
        isMissing = table[key].some((el: any) => {
          if (
            el.columnName?.toLowerCase() === fieldName?.toLowerCase() &&
            el.dataType === dataType
          ) {
            newTableId = key;
            return true;
          } else return false;
        });
      }
    });
  } else {
    tableColumnsData.forEach((table: any) => {
      if (table[column.tableId] && table[column.tableId].length > 0) {
        const fieldName = column.fieldname ?? column.fieldName ?? column.displayname ?? '';
        const dataType = column?.originalDataType ?? column?.dataType ?? column?.datatype ?? '';
        isMissing = !table[column.tableId].some((el: any) => {
          return (
            el?.columnName.toLowerCase() === fieldName?.toLowerCase() && el.dataType === dataType
          );
        });
      }
    });
  }

  if (switchDataset) {
    return { newTableId, isMissing };
  }

  return { isMissing };
};

export const checkIfTableExists = (tableId: string, tablesOfDataset: any[]) => {
  const table = tablesOfDataset.find((table: any) => table.id === tableId);
  if (table) {
    return true;
  }
  return false;
};

export const getColumnFromUid = (chartAxes: any, uId: string): ChartDataFieldProps | null => {
  const newChartAxes = chartAxes.filter((axis: any) => axis.name !== 'Filter');
  for (const axis of newChartAxes) {
    for (const field of axis.fields || []) {
      if (field.uId === uId) {
        return {
          fieldname: field.fieldname,
          dataType: field.dataType,
          displayname: field.displayname,
          tableId: field.tableId,
          uId: field.uId,
        };
      }
    }
  }
  return null;
};

/**
 *
 * This function logically changes rounding digit of a field.
 * for all count operation & integers rounding digits will be 0, for decimals it will be 2
 * @returns roundingDigits
 */
export const getRoundingDigits = (field: any) => {
  let roundingDigits = 1;
  const countParams = new Set(['count', 'countnn', 'countn', 'countu']);
  const aggregationisCount = countParams.has(field.agg);
  const isInteger =
    (field.dataType === 'integer' && field.agg !== 'avg') ||
    ((field.dataType === 'timestamp' || field.dataType === 'date') && field.timeGrain !== 'date');
  roundingDigits = aggregationisCount || isInteger ? 0 : field.dataType === 'decimal' ? 2 : 1;
  return roundingDigits;
};
